(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kiplo-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kiplo-product'))customElements.define('kiplo-product',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const sel=this.querySelector('[data-variant]'),img=this.querySelector('.kp-main'),stage=this.querySelector('.kp-stage'),zoom=this.querySelector('.kp-zoom'),btn=this.querySelector('[data-submit]');const show=(src,alt)=>{if(!src||!img)return;img.removeAttribute('srcset');img.src=src;if(alt)img.alt=alt;stage.classList.remove('zoom');zoom.setAttribute('aria-pressed','false');};this.addEventListener('click',e=>{const photo=e.target.closest('button[data-photo]'),pick=e.target.closest('[data-pick]');if(photo)show(photo.dataset.photo);if(pick){sel.value=pick.dataset.pick;sel.dispatchEvent(new Event('change',{bubbles:true}));}if(e.target.closest('.kp-zoom'))zoom.setAttribute('aria-pressed',String(stage.classList.toggle('zoom')));});sel?.addEventListener('change',()=>{const o=sel.selectedOptions[0];show(o.dataset.photo,o.textContent.trim());this.querySelector('[data-price]').textContent=o.dataset.price;this.querySelector('[data-sticky-price]').textContent=o.dataset.price;btn.disabled=o.dataset.available!=='true';btn.textContent=btn.disabled?btn.dataset.sold:btn.dataset.add;this.querySelectorAll('[data-pick]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pick===sel.value)));const url=new URL(location.href);url.searchParams.set('variant',sel.value);history.replaceState(null,'',url);});const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;if('IntersectionObserver'in window){this.reveal=new IntersectionObserver(entries=>entries.forEach(x=>{if(x.isIntersecting){if(!reduced)x.target.animate([{opacity:0,transform:'translateY(20px)'},{opacity:1,transform:'translateY(0)'}],{duration:500,easing:'ease-out'});this.reveal.unobserve(x.target);}}),{threshold:.12});this.querySelectorAll('[data-reveal]').forEach(e=>this.reveal.observe(e));this.sticky=new IntersectionObserver(([x])=>{this.querySelector('.kp-sticky').hidden=x.isIntersecting||x.boundingClientRect.top>0;});const buy=this.querySelector('.kp-buy');if(buy)this.sticky.observe(buy);}this.querySelectorAll('.kp-specs details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open&&!reduced)d.querySelector('div')?.animate([{opacity:0,transform:'translateY(-6px)'},{opacity:1,transform:'translateY(0)'}],{duration:220});}));}
disconnectedCallback(){this.reveal?.disconnect();this.sticky?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
